import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { useTypedSelector } from "../../../../../../redux/store";
import { CellContentRoot } from "../../../../../LightTable";

const ColorCellContent: React.FC<ColorCellContent.Props> = ({ item }) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item.color?.name?.[lang] ?? "",
		[item.color?.name, lang],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ColorCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default ColorCellContent;
